import { CLEAR_ACCOUNT_DATA } from 'constants/actionTypes';
import {
  SET_ACCOUNT_TAGS_ERRORED,
  SET_ACCOUNT_TAGS_FETCHING,
  REPLACE_ACCOUNT_TAGS,
  UPDATE_TAGS_MANAGEMENT_STATE,
} from 'constants/account/tags';
import { selectFlowTags } from 'reducers/account/flows';

const initialState = {
  meta: {
    fetching: false,
    synced: false,
    errored: false,
  },
  tagsManagementState: {
    errorMessage: null,
    successMessage: null,
  },
  data: {},
};

export default function tags(state = initialState, action) {
  switch (action.type) {
    case SET_ACCOUNT_TAGS_FETCHING:
      return {
        ...state,
        meta: {
          fetching: true,
          synced: false,
          errored: false,
        },
      };
    case REPLACE_ACCOUNT_TAGS:
      return {
        ...state,
        meta: {
          fetching: false,
          synced: true,
          errored: false,
        },
        data: action.payload,
      };
    case SET_ACCOUNT_TAGS_ERRORED:
      return {
        ...state,
        meta: {
          fetching: false,
          synced: true,
          errored: true,
        },
      };
    case UPDATE_TAGS_MANAGEMENT_STATE:
      return {
        ...state,
        tagsManagementState: action.payload,
      };
    case CLEAR_ACCOUNT_DATA:
      return initialState;
    default:
      return state;
  }
}

export const selectAccountTags = state => {
  return state.account.tags.data || {};
};
export const selectAccountTag = (state, tagId) =>
  selectAccountTags(state)[tagId];
export const selectAccountTagsMeta = state => state.account.tags.meta;
export const selectAccountTagsSynced = state => state.account.tags.meta.synced;
export const selectAccountTagsManagementState = state =>
  state.account.tags.tagsManagementState;

export const selectTagsForFlow = (state, flowId) =>
  selectFlowTags(state, flowId).map(
    tagId => selectAccountTag(state, tagId) || { id: tagId }
  );
export const selectUnusedTagsForFlow = (state, flowId) =>
  Object.values(selectAccountTags(state)).filter(
    ({ id }) => !selectFlowTags(state, flowId).includes(id)
  );
